module.exports = __webpack_public_path__ + "pc/img/swiper_bg_03.f19ca6b3.png";